import { render, staticRenderFns } from "./ViewerContainer.vue?vue&type=template&id=4bc47153"
import script from "./ViewerContainer.vue?vue&type=script&lang=js"
export * from "./ViewerContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports